const didTriggerGoogleAnalyticsForRoiCalculatorField = require("./didTriggerGoogleAnalyticsForRoiCalculatorField");
const didFieldValueUpdate = require("./didFieldValueUpdate");
const triggerGoogleAnalyticsEventForRoiCalculatorFormField = require("./triggerGoogleAnalyticsEventForRoiCalculatorFormField");
const markRoiCalculatorFieldGoogleAnalyticsAsTriggered = require("./markRoiCalculatorFieldGoogleAnalyticsAsTriggered");

/**
 * @param savedCalculatorData {RoiCalculatorFormData}
 * @param calculatorData {RoiCalculatorFormData}
 * @return {void}
 */
module.exports = function triggerGoogleAnalyticsEventForRoiCalculatorFormFields(savedCalculatorData, calculatorData) {
    for (let fieldName in calculatorData) {
        if (
            !didTriggerGoogleAnalyticsForRoiCalculatorField(fieldName) &&
            didFieldValueUpdate(savedCalculatorData[fieldName], calculatorData[fieldName])
        ) {
            triggerGoogleAnalyticsEventForRoiCalculatorFormField(fieldName);

            markRoiCalculatorFieldGoogleAnalyticsAsTriggered(fieldName);
        }
    }
}
